var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SaleHeader',{attrs:{"img_header":_vm.header_image,"header":"ตั้งค่าข้อมูลการขาย","link_back":"managewebsite"}}),_c('MenuSale'),_c('Transfer_setting')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }